"use client";

import React from "react";
import { Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-zinc-800/50 animate-pulse rounded-md" />)}
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-secondary hover:text-primary transition-colors text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function PieDePaginaArtek() {
  return <section data-section-id="234732" id="footer" className="dark bg-foreground text-secondary pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img src="https://fun-bengal.10web.cloud/wp-content/uploads/2026/05/senditfit_header_optimised.png" alt="Send It Fit" className="h-14 w-auto" />
            </Link>
            <p className="text-secondary/80 text-sm leading-relaxed max-w-xs font-default">We take fitness seriously, so you can take life less seriously. Mobile personal training bringing good vibes to Singapore.</p>
          </div>

          {}
          

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 text-secondary">
              Location
            </h3>
            <ul className="space-y-4 text-sm text-secondary/80 font-default">
              <li className="flex items-start gap-3">
                <MapPin className="size-5 shrink-0 text-primary mt-0.5" />
                <span>Wherever you want us!</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-5 shrink-0 text-primary" />
                <span>+65 8899 0728</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-5 shrink-0 text-primary" />
                <span>lets@senditfit.com</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 text-secondary">
              Socials
            </h3>
            <div className="flex gap-3">
              <Button variant="ghost" size="icon" asChild className="text-secondary hover:text-primary hover:bg-secondary/10 rounded-lg transition-colors">
                <Link to="https://www.instagram.com/sendit.fit/" newTab aria-label="Follow Send It Fit on Instagram - fitness training Singapore">
                  <Instagram className="size-5" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" asChild className="text-secondary hover:text-primary hover:bg-secondary/10 rounded-lg transition-colors">
                <Link to="https://www.facebook.com/senditfit/" newTab aria-label="Follow Send It Fit on Facebook - mobile personal training Singapore">
                  <Facebook className="size-5" />
                </Link>
              </Button>
              <Button variant="ghost" size="lg" asChild className="hover:text-secondary hover:text-primary hover:bg-secondary/10 rounded-lg transition-colors">
  <Link href="https://www.tiktok.com/@senditfit" rel="noreferrer noopener" target="_blank" aria-label="Follow Send It Fit on TikTok - mobile personal training Singapore">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#1a1a1a" className="h-6 w-6">
  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.66 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.7-.1z" />
                </svg>
  </Link>
            </Button>
            </div>
          </div>
        </div>

        <Separator className="bg-secondary/20 mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-sm text-secondary/60">
          <div className="flex flex-wrap justify-center gap-6 font-default">
            <Link to="https://senditfit.com/privacy-policy/" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="https://senditfit.com/terms-of-service/" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
          <p className="font-mono text-2xl text-secondary/40 tracking-wide uppercase">© Send It Fit LLP</p>
        </div>
      </div>
    </section>;
}